export const flightDetailHeader = [
  'From City',
  'To Country',
  'To City',
  'Date',
  'Dept. Time',
  'Pref. Airline',
  'Class',
];

export const hotelDetailHeader = [
  'Country',
  'Place',
  'Check In Date',
  'Check Out Date',
  'Pref. Hotel',
];

export const clientDetailHeader = [
  'Client Name',
  'Company',
  'Contact No.',
  'Project Name',
];
